import { CheckCircle2, MessageCircle } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import { detailedServices, trustBadges } from "../data/siteContent";
import { defaultWhatsAppMessage, whatsappUrl } from "../lib/whatsapp";

export default function Services() {
  return (
    <>
      <section className="page-hero" data-testid="services-hero-section">
        <div className="container">
          <span className="eyebrow" data-testid="services-eyebrow">AI-smart, human-led career support</span>
          <h1 className="page-title" data-testid="services-page-title">Modern Job-Search Support That Feels Human</h1>
          <p className="page-intro" data-testid="services-page-intro">Each service combines employability experience, clear guidance and smart tools to help you present your experience with confidence.</p>
        </div>
      </section>

      <section className="section compact" data-testid="services-detail-section">
        <div className="container">
          <div className="card-grid" data-testid="services-detail-grid">
            {detailedServices.map((service) => (
              <article className="detail-block fade-in" key={service.slug} data-testid={`services-${service.slug}-detail-card`}>
                {service.image && <div className="detail-image" data-testid={`services-${service.slug}-image-wrap`}><img src={service.image} alt={service.alt} data-testid={`services-${service.slug}-image`} /></div>}
                <h3 data-testid={`services-${service.slug}-title`}>{service.title}</h3>
                <p className="body-copy" data-testid={`services-${service.slug}-intro`}>{service.intro}</p>
                <ul className="detail-list" data-testid={`services-${service.slug}-list`}>
                  <li data-testid={`services-${service.slug}-for`}><CheckCircle2 size={18} /> <span><strong>Who it is for:</strong> {service.for}</span></li>
                  {service.helps.map((item, index) => <li key={item} data-testid={`services-${service.slug}-helps-${index + 1}`}><CheckCircle2 size={18} /> <span>{item}</span></li>)}
                </ul>
                <a className="btn btn-secondary" href={whatsappUrl(`Hi Ben, I would like to ask about ${service.title}.`)} target="_blank" rel="noopener noreferrer" data-testid={`services-${service.slug}-ask-button`}><MessageCircle size={18} /> Ask about this service</a>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section compact" data-testid="services-remote-section">
        <div className="container remote-panel">
          <div>
            <h2 data-testid="services-remote-title">Remote Support Across the UK</h2>
            <p data-testid="services-remote-text">Job Boost by Ben can support you remotely by WhatsApp, email or video call. You do not need to travel. Whether you are in London, Birmingham, Manchester, Leeds, Bristol, Glasgow or anywhere else in the UK, you can get practical career support from home.</p>
          </div>
          <a className="btn btn-primary" href={whatsappUrl(defaultWhatsAppMessage)} target="_blank" rel="noopener noreferrer" data-testid="services-remote-whatsapp-button"><MessageCircle size={18} /> Message Ben on WhatsApp</a>
        </div>
      </section>

      <section className="section white-band" data-testid="services-trust-section">
        <div className="container">
          <SectionHeading title="You do not need to have it all figured out" text="Many people feel stuck when applying for jobs. Sometimes the issue is not your experience, but how it is being presented. Job Boost by Ben helps you organise your experience, improve your wording and prepare with more confidence." testId="services-trust-heading" />
          <div className="trust-badges" data-testid="services-trust-badges">
            {trustBadges.map((badge, index) => <span className="trust-badge" key={badge} data-testid={`services-trust-badge-${index + 1}`}><CheckCircle2 size={18} /> {badge}</span>)}
          </div>
        </div>
      </section>
    </>
  );
}